import { useTranslation } from 'react-i18next'

import Button from '../../Button'

function TableModalButtonAttach({
  Component = Button.Contained,
  text = 'Modal.AttachActionKey',
  ...restProps
}) {
  const { t } = useTranslation()

  return <Component {...restProps} text={t(text)} />
}

export default TableModalButtonAttach
